import { createCrudPage } from './factories/crud-page.js';
import { escapeHtml } from '../core/dom/escape-html.js';

export default createCrudPage({
  title: 'Company Sectors',
  basePath: '/company-sectors',
  columns: [
    { key: 'type', label: 'Sector type', sortable: true,
      render: (v) => (/** @type {unknown} */ (v) === 1 || v === '1' || v === true) ? 'Trade' : 'Services' },
    { key: 'title', label: 'Sector', sortable: true },
    { key: 'fa_class', label: 'Icon', sortable: true,
      render: (v) => `<i class="fa fa-${escapeHtml(String(v ?? ''))}"></i>`,
      renderHtml: true },
  ],
  fields: [
    { key: 'type', label: 'Sector type', type: 'select', required: true,
      options: [
        { label: 'Trade', value: '1' },
        { label: 'Services', value: '2' },
      ] },
    { key: 'title', label: 'Sector', type: 'text', required: true },
    { key: 'fa_class', label: 'Fa icon', type: 'text' },
  ],
  defaultSort: { field: 'type', dir: 'desc' },
});
